import "./styles.css";
import React from "react";
import ReactGA from 'react-ga';
import { MainWindow } from "./components/Main";
import { ThemeProvider, createTheme } from '@mui/material';
import { purple } from '@mui/material/colors'
import { BrowserRouter } from 'react-router-dom';


String.prototype.format = function () {
  // store arguments in an array
  var args = arguments[0];
  // use replace to iterate over the string
  // select the match and check if related argument is present
  // if yes, replace the match with the argument
  return this.replace(/{([0-9,a-z,A-Z]+)}/g, function (match, index) {
    // check if the argument is present
    return typeof args[index] == "undefined" ? match : args[index];
  });
};

ReactGA.initialize('UA-208955450-1', [])

const theme = createTheme({
  palette: {
    primary: {
      main: "#C3B490"
    },
    copyButton: { main: "#B1B1B1" },
    secondary: purple,
    text: {
      primary: "#000000",
      secondary: "#828184",
      commandBox: "#5E5C61",
    }
  },
  typography: {
    fontFamily: 'Barlow',
    fontWeightLight: 400,
    body2: {
      fontFamily: "Barlow"
    },
    checkbox: {
      fontSize: '0.9rem'
    },
    headerAppBar: {
      fontFamily: "Barlow",
      fontStyle: "normal",
      fontWeight: "300",
      fontSize: "28px",
      display: "flex",
      color: 'white',
      textTransform: 'uppercase',
    },
    toolsNavigation: {
      textTransform: 'uppercase',
      fontSize: "0.9rem"
    }
  },
  components: {
    MuiCssBaseline: {},
    MuiSelect: {},
    MuiTextField: {
      variants: [
        {
          props: { size: "xsmall" },
          style: {
            height: "200px",
          }
        }
      ]
    }
  },
  MuiSelect: {
    select: {
      "&:focus": {
        backgroundColor: '#ffddec',
        borderColor: 'brown'
      },
      '&:before': {
        borderColor: 'orange'
      },
      '&:after': {
        borderColor: 'green',
      }
    }
  }
})

export default function App() {

  return (
    <ThemeProvider theme={theme}>
      {/* <div className="App"> */}
      <BrowserRouter
        basename={process.env.PUBLIC_URL}>
        <MainWindow />
      </BrowserRouter>
      {/* </div> */}
    </ThemeProvider>
  );
}